import React, { useState } from "react";
import { Form, Input, Button, Card, Typography, Spin, message } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import "./ForgotPass.css";
import ChangePassImg from "../../assets/resetPass.png";

const { Title } = Typography;

const ForgotPasswordForm = () => {
  const [loading, setLoading] = useState(false); // State to manage spinner
  const navigate = useNavigate();

  const onFinish = async (values) => {
    ////console.log("Forgot Password Request:", values);

    // Simulate API call
    setLoading(true); // Show spinner
    try {
      // Replace this with your API call
      ////console.log("Employee Number:", values.empno);

      // Simulate a delay for demonstration
      await new Promise((resolve) => setTimeout(resolve, 2000));

      message.success("Password reset link sent to your email!");
      navigate("/login"); // Redirect to login page
    } catch (error) {
      ////console.error("Error:", error);
      message.error("Failed to send reset password link. Please try again.");
    } finally {
      setLoading(false); // Hide spinner
    }
  };

  return (
    <Spin spinning={loading} tip="Processing...">
      <div className="forgot-password-container">
        <div className="forgot-password-content">
          {/* Left Column: Animated Image */}
          <div className="forgot-password-image-container">
            <img
              src={ChangePassImg}
              alt="Forgot Password Illustration"
              className="forgot-password-image animated"
            />
          </div>

          {/* Right Column: Form */}
          <div className="forgot-password-form-container">
            <Card title="Forgot Password" style={{ width: 400, borderRadius: "8px" }}>
              <Title level={4} className="forgot-password-title">
                Reset Your Password
              </Title>
              <Form name="forgotPassword" onFinish={onFinish} layout="vertical">
                <Form.Item
                  label="Employee Number"
                  name="empno"
                  rules={[{ required: true, message: "Please input your employee number!" }]}
                >
                  <Input
                    prefix={<UserOutlined />}
                    placeholder="Enter your employee number"
                  />
                </Form.Item>

                <Form.Item>
                  <Button type="primary" htmlType="submit" block>
                    Reset Password
                  </Button>
                </Form.Item>
              </Form>
            </Card>
          </div>
        </div>
      </div>
    </Spin>
  );
};

export default ForgotPasswordForm;
